import React, { useCallback } from 'react';
import { Tag } from 'antd';
import { INVOICE_STATUS_COLORS, INVOICE_STATUS_ICONS } from '../constants';

export const useInvoiceStatusRender = () => {
  return useCallback((status: string) => {
    if (!status) return '-';

    const color =
      INVOICE_STATUS_COLORS[status as keyof typeof INVOICE_STATUS_COLORS] ||
      'default';
    const icon =
      INVOICE_STATUS_ICONS[status as keyof typeof INVOICE_STATUS_ICONS] || null;

    return (
      <Tag
        color={color}
        icon={icon && React.createElement(icon)}
        style={{ fontWeight: 500 }}
      >
        {status}
      </Tag>
    );
  }, []);
};
